import React, { useRef } from "react"
import { Menu } from "primereact/menu"
import { TEAM_VACATION_REQUESTS_FILTER_OPTIONS } from "../../../../consts/modules/vacations.consts"

const TeamMemberVacationsHeader = ({
  selectedFilter,
  setSelectedFilter,
  vacationRequests,
}) => {
  const sortPanelRef = useRef(null)

  const hasFilter =
    TEAM_VACATION_REQUESTS_FILTER_OPTIONS.past_requests !==
      selectedFilter.past_requests ||
    TEAM_VACATION_REQUESTS_FILTER_OPTIONS.rejected_requests !==
      selectedFilter.rejected_requests

  const menuItems = [
    {
      label:
        selectedFilter.past_requests ? "Ocultar pasadas" : "Mostrar pasadas",
      command: () =>
        setSelectedFilter((prev) => ({
          ...prev,
          past_requests: !prev.past_requests,
        })),
    },
    {
      label:
        selectedFilter.rejected_requests ? "Ocultar rechazadas" : (
          "Mostrar rechazadas"
        ),
      command: () =>
        setSelectedFilter((prev) => ({
          ...prev,
          rejected_requests: !prev.rejected_requests,
        })),
    },
  ]

  return (
    <div className="flex flex-column gap-3">
      <div className="flex justify-content-between align-items-center relative">
        <h3 className="text-xl m-0 font-cairo">Solicitudes</h3>
        <i
          className={`pi pi-filter${hasFilter ? "-fill" : ""} cursor-pointer ${
            vacationRequests.length === 0 && "p-disabled"
          }`}
          onClick={(event) => sortPanelRef.current.toggle(event)}
        />
        <Menu
          model={menuItems}
          popup
          ref={sortPanelRef}
          className="custom-sort-overlay-panel"
          appendTo={"self"}
        />
      </div>
    </div>
  )
}

export default TeamMemberVacationsHeader
